import { Flex, Text, TextField, Switch } from '@radix-ui/themes';
import React from 'react';

const SearchFilter = ({
  searchQuery,
  setSearchQuery,
  showActiveOnly,
  setShowActiveOnly,
  placeholder = "Search (min 3 chars)",
  onSearchChange = () => {},
  onActiveToggle = () => {},
}) => {
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    onSearchChange(value); // Allow parent to react (e.g., reset page)
  };

  const handleToggleChange = (checked) => {
    setShowActiveOnly(checked);
    onActiveToggle(checked); // Allow parent to react (e.g., reset page)
  };

  return (
    <Flex gap="3" align="center">
      <TextField.Root
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleSearchChange}
        size="2"
        style={{ width: '300px' }}
        className="rounded"
      />
      <Text as="label" size="2">
        <Flex gap="2" align="center">
          <Switch checked={showActiveOnly} onCheckedChange={handleToggleChange} size="1" />
          Active Only
        </Flex>
      </Text>
    </Flex>
  );
};

export default SearchFilter;